// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__9JbY7","actions":"GroupTable_actions__2GF3c","deleteModalFooter":"GroupTable_deleteModalFooter__39jBo"};